export default function Notifications() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Notifications</h1>
      <p className="text-gray-600">Notifications page is under construction.</p>
    </div>
  );
}